<template>
  <div class="edit-content">
    <div class="topEdit">
      <EditHeader :backShow="true" headerTitle="阅读效果编辑"></EditHeader>
      <el-collapse class="edit-collapse" v-model="activeName" accordion>
        <el-collapse-item title="基础设置" name="1">
          <EditBase ref="editBase"></EditBase>
        </el-collapse-item>
        <el-collapse-item class="edit-bg-wrapper" title="背景模板" name="2">
          <EditBg ref="editBg" @getFile="getFile"></EditBg>
        </el-collapse-item>
        <el-collapse-item :title="isPaper ? '版次目录' : '书刊目录'" name="3">
          <EditCatalog @saveCatalog="saveData" ref="editCatalog"></EditCatalog>
        </el-collapse-item>
        <el-collapse-item class="edit-personal-wrapper personal-custom" title="个性设置" name="4">
          <EditPersonal ref="editPersonal" @checkcallback="checkCallback" @adornmentMsn="adornmentMsn"></EditPersonal>
        </el-collapse-item>
        <el-collapse-item class="edit-personal-wrapper" :title="isPaper ? '报纸运营' : '书刊运营'" name="5">
          <EditPerRun ref="editPerRun" :is-paper="isPaper" @saveRunThen="saveThen" @checkcallback="questionaireCheckCallback"></EditPerRun>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="edit-footer" id="edit-footer">
      <div class="edit-footer-item left" @click="saveThen('curPage')">保存当前设置</div>
      <div class="edit-footer-item right" @click="saveThen('goList')" v-if="isPaper">保存并返回列表</div>
      <div class="edit-footer-item right" @click="saveThen('goList')" v-else>保存并返回我的书刊</div>
    </div>
  </div>
</template>
<script>
import apis from '@api/setBook'
import EditPerRun from './EditPerRun.vue'
import EditHeader from './EditHeader.vue'
import EditBase from './EditBase.vue'
import EditBg from './EditBg.vue'
import EditPersonal from './EditPersonal.vue'
import EditCatalog from './EditCatalog.vue'
import { isLogin, base64ToFile, sliceStrPicUrl, getStrByteCount } from '@/utils'
export default {
  data() {
    return {
      saveEvent: () => {
        if (event.ctrlKey == true && event.keyCode == 83) {
          event.preventDefault()
          event.returnvalue = false
          this.saveThen('curPage')
        }
      }, // 保存的事件对象
      saveErrorMessage: '请完善必填项信息',
      activeName: '1',
      checkReason: false,
      questionaireCheckReason: false, //临时：问卷有不符合要求的数据时，弹出的提示与其他的不一致
      adornment: null,
      file: null,
      cusBg: null, //上传自定义背景
      isPaper: this.$route.path.indexOf('paper') > -1,
      cropImgUrl: null
    }
  },
  components: {
    EditPerRun,
    EditHeader,
    EditBg,
    EditBase,
    EditPersonal,
    EditCatalog
  },
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    userName() {
      return localStorage.getItem('username')
    },
    posterBook() {
      return this.$store.state.config.poster.book
    },
    listToEditPageNo() {
      return this.$store.state.edit.listToEditPageNo
    },
    isPublish() {
      return this.$store.state.config.isPublish
    }
  },
  mounted() {
    // Ctrl+s保存快捷键
    document.addEventListener('keydown', this.saveEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.saveEvent)
  },
  methods: {
    /**
     * 是否是数字报刊
     * @returns {boolean}
     */
    hasPaper() {
      return window.location.href.indexOf('/paper?') !== -1 || window.location.href.indexOf('/paperTurn?') !== -1
    },
    // 保存及之后的操作
    saveThen(goToWhere) {
      // goToWhere表示保存后的操作 （curPage | goList）
      isLogin()
      const { selPoster, customTit, downloadValue, pdfStatus, zipStatus, epubStatus } = this.$refs.editPersonal
      if (selPoster == 1 && !customTit) {
        this.$message({
          message: '请设置风格名称',
          type: 'error'
        })
        return
      }
      // 若选择可下载，则必须选择至少一种类型
      if (downloadValue !== 0 && !pdfStatus && !zipStatus && !epubStatus) {
        this.$message({
          message: '请至少选择一项开放文件下载类型',
          type: 'error'
        })
        return
      }
      if (this.bookObj.voiceSpeed === 3 && (this.bookObj.userVoiceSpeed < 1 || this.bookObj.userVoiceSpeed > 100 || !this.bookObj.userVoiceSpeed || this.bookObj.userVoiceSpeed % 1 !== 0)) {
        this.$message({
          message: '请设置自定义语速，输入1-100整数',
          type: 'error'
        })
        return
      }
      this.saveData(goToWhere)
    },
    async saveData(type) {
      //先校验
      if (this.file) {
        this.cusBg = await this.picChangeUrl('background', this.file)
      }
      let bgMusic = null
      if (this.$refs.editPersonal.bgMusic && this.$refs.editPersonal.audioFile) {
        const result = await this.setbgMusic()
        if (result && result.data.code === 0) {
          bgMusic = sliceStrPicUrl(result.data.data)
          this.$refs.editPersonal.audioFile = null
          this.$store.commit('config/UPDATE_BGMUSIC', bgMusic) // 保存背景音乐到store中
        } else {
          this.$alert('背景音乐上传失败，请重新保存当前设置', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
      } else {
        bgMusic = this.$refs.editPersonal.bgMusic ? sliceStrPicUrl(this.bookObj.bgMusic || '') : ''
      }
      let thumbnail = ''
      if (this.bookObj.thumbnail && this.bookObj.thumbnail.includes('data:image')) {
        thumbnail = await this.picChangeUrl('thumbnail', this.bookObj.thumbnail)
      } else {
        thumbnail = this.bookObj.thumbnail === 'default' || this.bookObj.thumbnail === null ? '' : sliceStrPicUrl(this.bookObj.thumbnail)
      }
      this.$refs.editPersonal.check()
      this.$refs.editPerRun.check()

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.checkReason && this.questionaireCheckReason) {
            let catalogData = { catalogId: this.bookObj.catalogId, catalogList: this.bookObj.catalogList }
            let currentBgUrl = this.bookObj.currentBgUrl
            let curBgIndex = currentBgUrl.split('.')[0].split('/bg')[1]
            let finalBg = curBgIndex
            if (isNaN(parseFloat(curBgIndex)) || this.bookObj.currentBgImg === 'custom') {
              if (currentBgUrl && currentBgUrl.length > 0) {
                // finalBg = currentBgUrl.slice(currentBgUrl.indexOf('resourceDir/'))
                finalBg = handleStr(currentBgUrl)
              }
            }
            let replacepc
            let logo = null
            if (this.$refs.editPersonal.logo == 0) {
              logo = 'logo.png'
            } else if (this.$refs.editPersonal.logo == 1) {
              let judgeLogoThumbnail = this.$store.state.config.logoThumbnail
              if (judgeLogoThumbnail && judgeLogoThumbnail.length > 0) {
                logo = judgeLogoThumbnail.slice(judgeLogoThumbnail.indexOf('attach/'))
              }
              const pcurl = this.$store.state.config.pcLogo
              replacepc = handleStr(pcurl)
            }
            // 过渡页加载图片
            let loadPic = null
            if (this.$refs.editPersonal.loadPic == 0) {
              loadPic = 'logo.png'
            } else if (this.$refs.editPersonal.loadPic == 1) {
              let judgeLoadingPic = this.$store.state.config.book.loadingPic
              if (judgeLoadingPic && judgeLoadingPic.length > 0) {
                loadPic = judgeLoadingPic.slice(judgeLoadingPic.indexOf('attach/'))
              }
            }
            // 下载设置参数
            const download = this.$refs.editPersonal.downloadValue
            const formatList = download == 0 ? '' : this.$refs.editPersonal.formatList.toString()
            // 读物分类
            let publishDate = ''
            if (this.$refs.editBase.classify === 1) {
              publishDate = this.$refs.editBase.issuingDate
            } else if (this.$refs.editBase.classify === 0) {
              publishDate = this.$refs.editBase.publicationYear
            }
            let posterPic = handleStr(this.$refs.editPersonal.cusImg) || 'poster.png'
            const questionaireData = this.$refs.editPerRun.getData().questionaireData
            let shoppingGuideLinkIcon = ''
            if (this.bookObj.buyIcon && this.bookObj.buyIcon.length && this.bookObj.buyIcon.length > 0) {
              shoppingGuideLinkIcon = this.bookObj.buyIcon.substring(this.bookObj.buyIcon.indexOf('attach/'))
            }
            let buyIconLen = getStrByteCount(this.bookObj.buyIcon)
            let questionIconLen = getStrByteCount(this.bookObj.questionIcon)
            if ((this.bookObj.buyIconType >= 20 && (buyIconLen > 12 || buyIconLen < 1)) || (this.bookObj.questionIconType >= 20 && (questionIconLen > 12 || questionIconLen < 1))) {
              this.$message({ message: '未按要求输入文字内容', type: 'error' })
              return
            }
            let chargeIcon = ''
            if (this.bookObj.chargeIconType >= 20) {
              chargeIcon = JSON.stringify({
                style: this.bookObj.chargeIconType,
                text: this.bookObj.chargeIcon
              })
              let chargeIconLent = getStrByteCount(this.bookObj.chargeIcon)
              if (chargeIconLent > 12 || chargeIconLent < 1) {
                this.$message({ message: '未按要求输入文字内容', type: 'error' })
                return
              }
            } else if (this.bookObj.chargeIconType !== -1) {
              chargeIcon = this.bookObj.chargeIconType
            } else if (this.bookObj.chargeIcon && this.bookObj.chargeIcon.length && this.bookObj.chargeIcon.length > 0) {
              chargeIcon = this.bookObj.chargeIcon.substring(this.bookObj.chargeIcon.indexOf('attach/'))
            }
            function handleStr(pcurl) {
              if (pcurl) {
                return pcurl.substring(pcurl.indexOf('attach'))
              } else {
                return ''
              }
            }
            let initDisplayOrNot = JSON.stringify(this.$store.state.config.bookObj.displayOrNot)
            let displayOrNot = initDisplayOrNot
            const editParams = {
              id: this.bookObj.id,
              catalog: JSON.stringify(catalogData),
              title: this.bookObj.shareTitle.trim(),
              description: this.bookObj.shareDesc,
              thumbnail: thumbnail,
              backgroud: finalBg,
              openSound: this.bookObj.soundOn ? 1 : 0,
              pageSound: this.bookObj.soundId,
              voiceNumber: this.bookObj.voiceNumber,
              //
              buttonStyle: this.bookObj.buttonStyle,
              bookBinding: this.bookObj.bookBinding,
              shop: this.bookObj.shop,
              buyLink: this.bookObj.buyLink,
              shoppingGuideLinkIconOption: this.bookObj.buyIconType,
              shoppingGuideLinkIcon: shoppingGuideLinkIcon,
              //
              loadEffect: this.bookObj.loadingId,
              loadText: this.bookObj.ruleForm.loadingText,
              loadColor: this.bookObj.loadingColor,
              openCatalog: 0,
              charge: this.bookObj.charge,
              chargeIcon: chargeIcon,
              price: 0.0,
              chargeIndex: 1,
              adornment: this.adornment ? this.adornment.substring(this.adornment.indexOf('attach/')) : '',
              logo: logo,
              jump: this.$store.state.config.bookObj.logoUrlOpen,
              longPress: this.$store.state.config.bookObj.longPress,
              copyText: this.$store.state.config.bookObj.copyText,
              navbarSwtich: this.$store.state.config.bookObj.navbarSwtich,
              url: this.$refs.editPersonal.logoUrl,
              loadPic: loadPic, //电子书加载图片
              autoPageTurn: 0,
              pageTurnInterval: null,
              poster: this.$refs.editPersonal.isPoster,
              posterStyle: this.$refs.editPersonal.selPoster,
              posterTitle: this.$refs.editPersonal.selPoster == 0 ? '' : this.$refs.editPersonal.customTit,
              posterPic: posterPic,
              posterQrCodeShow: this.posterBook.posterQrCodeShow,
              posterNameShow: this.posterBook.posterNameShow,
              posterName: this.posterBook.posterName,
              posterTextShow: this.posterBook.posterTextShow,
              posterPromptText: this.posterBook.posterPromptText,
              posterCover: this.posterBook.posterCover.filter((_) => _).toString(),
              articleLayout: this.$refs.editPersonal.articleLayout,
              articleHighlight: this.$refs.editPersonal.articleHighlight,
              downloadScope: download,
              downloadFormat: formatList,
              category: this.$refs.editBase.classify,
              publishDate: publishDate,
              bgMusic: this.$refs.editPersonal.bgMusic ? bgMusic : '',
              bgMusicSwitch: this.$refs.editPersonal.bgMusic,
              bgMusicLoop: this.$refs.editPersonal.bgMusic ? this.$refs.editPersonal.circulatePlay : 0,
              bgMusicName: this.$refs.editPersonal.bgMusic ? this.$refs.editPersonal.audioFileName || '背景音乐' : '背景音乐',
              displayOrNot: displayOrNot,
              officialWeb: this.bookObj.officialWeb,
              homePageUrl: this.bookObj.officialWeb ? this.bookObj.homePageUrl : '',
              homePageTitle: this.bookObj.officialWeb ? this.bookObj.homePageTitle : '',
              historyResource: this.bookObj.historyResource,
              entryName: this.bookObj.historyResource ? this.bookObj.entryName : '',
              entryUrl: this.bookObj.historyResource ? this.bookObj.entryUrl : '',
              ...questionaireData,
              colorSwitch: this.bookObj.colorSwitch,
              listenStyle: this.bookObj.listenStyle,
              voiceSpeed: this.bookObj.voiceSpeed,
              userVoiceSpeed: this.bookObj.userVoiceSpeed,
              sentenceRead: this.bookObj.sentenceRead,
              language: this.bookObj.language,
              winEffect: this.bookObj.winEffect
            }
            if (this.bookObj.colorSwitch === 1) {
              editParams.colorContent = JSON.stringify(this.bookObj.colorContent)
            }

            if (this.hasPaper()) {
              // 数字报刊时需要的参数字段
              editParams.baozhiId = this.bookObj.baozhiId
              editParams.path = this.bookObj.path?.substring(this.bookObj.path.indexOf('epaper'))
              editParams.pageNumber = this.bookObj.pageNumber
              // 身份&参数设置信息5个参数，这里只需要从报刊那里获取即可，实际设置有其它接口控制
              editParams.creator = this.userName
              editParams.open = this.bookObj.open
              editParams.dpi = this.bookObj.dpi
              editParams.referer = this.bookObj.referer
              editParams.displayPageNo = this.bookObj.displayPageNo
              editParams.readModel = this.bookObj.readModel
            }
            if (this.bookObj.style) {
              editParams.pcBuyLinkName = this.bookObj.pcBuyLinkName?.trim() || '导购'
              editParams.pcQuestionName = this.bookObj.pcQuestionName?.trim() || '问卷'
              editParams.pcLogo = replacepc
              editParams.style = 1
            }

            const requestHandler = (res) => {
              if (res && res.data && res.status === 200 && (res.data.status === 0 || res.data.code === 0)) {
                this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                })
                this.$store.commit('config/UPDATE_PCLOGO', this.$store.state.config.pcLogo)
                this.$store.commit('config/UPDATE_LOGOURL', editParams.url)
                if (this.$refs.editPersonal.logo == 0) {
                  let newValue1 = ''
                  this.$store.commit('config/UPDATE_LOGOTHUMBNAIL', newValue1)
                  this.$refs.editPersonal.uploadLogo = false
                }
                if (this.$refs.editPersonal.loadPic == 0) {
                  let newValue2 = ''
                  this.$store.commit('config/UPDATE_LOADINGPIC', newValue2)
                  this.$refs.editPersonal.loadTab = false
                }

                if (type == 'goList') {
                  // this.$router.push('/list')
                  this.$router.push({ name: 'list', params: { to: this.isPaper ? 'paper' : 'book', pageNo: this.listToEditPageNo } })
                  this.$store.commit('edit/UPDATE_LIST_TO_PAGE_NO', 1)
                } else {
                  this.$refs.editPersonal.getBookMsn()
                  // 问卷id
                  let data = res.data.data
                  let questionContent
                  questionContent = data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(data.questionContent) : {}
                  questionContent.formName = questionContent.formName ? questionContent.formName : data.title + '问卷'
                  let questionContentConstruction = data.questionnaire === 1 && data.questionType === 0 && data.questionContent ? JSON.parse(JSON.parse(data.questionContent).construction) : []
                  this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContent', value: questionContent })
                  this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: 'bookObj', key: 'questionContentConstruction', value: questionContentConstruction })
                }

                resolve()
                return res.data
              } else {
                this.$alert(`保存失败,原因${res?.data.message}`, '提示', {
                  confirmButtonText: '确定'
                })
                return Promise.reject('error')
              }
            }
            // api 请求直接失败
            const errorHandler = () => {
              return Promise.reject('error')
            }

            if (editParams.title !== '') {
              if (this.hasPaper()) {
                // 数字报刊
                apis.editEpaper(editParams).then(requestHandler, errorHandler)
              } else {
                // 电子书刊
                apis.editEbook(editParams).then(requestHandler, errorHandler)
              }
            } else {
              this.$message({ message: '请设置作品标题', type: 'error' })
            }
          } else {
            if (!this.checkReason) {
              this.$alert(this.saveErrorMessage, '提示', {
                confirmButtonText: '确定'
              })
            } else if (!this.questionaireCheckReason) {
              this.$message({ message: '请完成读者在线问卷设置', type: 'error' })
            }
            reject()
          }
        }, 0)
      })
    },
    checkCallback(value) {
      this.checkReason = value
    },
    questionaireCheckCallback(value) {
      this.questionaireCheckReason = value
    },
    adornmentMsn(value) {
      this.adornment = value
    },
    watchScroll() {
      $('#edit-footer').css({ top: document.body.clientHeight - 40 })
    },
    async setBackgroundCustom(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return apis.uploadPicture(params)
    },
    async picChangeUrl(payload, data) {
      const result = await this.setBackgroundCustom(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    async setbgMusic() {
      let params = new FormData()
      const audioFile = this.$refs.editPersonal.audioFile
      params.append('fieldName', 'mp3')
      params.append('mp3', audioFile)
      // zjx 20230113 根据接口要求，数字报时将ID为空，以解决上传成功无法返回数据的问题
      if (this.isPaper) {
        params.append('id', '')
      } else {
        params.append('id', this.bookObj.id)
      }
      return apis.uploadMusic(params)
    },
    getFile(file) {
      this.file = file
    }
  },
  created() {
    this.$store.dispatch('common/getVipInfo')
  },
  watch: {
    activeName() {
      if (this.activeName === '3') {
        this.$refs.editCatalog.treeFilter()
      }
    }
  }
}
</script>
<style lang="scss">
.edit-content {
  position: relative;
  height: calc(100% - 70px);
  overflow: hidden;
  .edit-collapse {
    position: absolute;
    width: 100%;
  }
}
.el-collapse-item__header {
  padding: 0 20px;
  background-color: #f4f4f4 !important;
  font-size: 16px !important;
  font-weight: bolder !important;
  color: #515151 !important;
}
.el-collapse-item__wrap {
  border-bottom: none !important;
  /*height: 320px;
  overflow-y: scroll !important;*/
}
.el-collapse-item__content {
  padding-bottom: 10px !important;
}
.edit-bg-wrapper {
  .el-collapse-item__content {
    height: 310px;
  }
}
.edit-personal-wrapper {
  .el-collapse-item__content {
    height: 280px;
    border-bottom: 1px solid #ebeef5;
  }
  &:last-of-type {
    .el-collapse-item__content {
      height: calc(100vh - 420px);
      margin-bottom: -50px;
    }
  }
}
.personal-custom {
  .el-collapse-item__content {
    height: 250px;
  }
}
.edit-footer {
  position: fixed;
  bottom: 40px;
  height: 30px;
  width: 100%;
  line-height: 30px;
  font-size: 14px;
  width: 300px;
  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    width: 50%;
    height: 100%;
    border: 1px solid #df5813;
    text-align: center;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      background-color: #fff;
      color: #df5813;
    }
  }
}
</style>
